import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';

import {
   ContinuouslyUsedMedicineIcon,
   IconFillColor,
   IconWrapper,
   RemoveIcon,
   Tooltip,
} from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { DeleteContinuousMedicationEventInterceptor } from './DeleteContinuousMedicationEventInterceptor';
import { useDeleteContinuouslyUsedMedicine } from './useDeleteContinuouslyUsedMedicine';

type DeleteContinuouslyUsedMedicineButtonProps = {
   readonly continuouslyUsedMedicineId: PatientMedicine['patientContinuouslyUsedMedicineId'];
   readonly onMedicineDeleted: (id: PatientMedicine['patientContinuouslyUsedMedicineId'] | undefined) => void;
   readonly medicineName: PatientMedicine['medicine']['fullName'];
   readonly medicineValid: boolean | undefined;
};

const DeleteContinuouslyUsedMedicineButton = (props: DeleteContinuouslyUsedMedicineButtonProps): JSX.Element => {
   const {
      execute: removeContinuouslyUsedMedicine,
      loading: removeContinuouslyUsedMedicineLoading,
   } = useDeleteContinuouslyUsedMedicine(props.continuouslyUsedMedicineId, props.onMedicineDeleted);

   const handleClick = (): void => {
      if (!removeContinuouslyUsedMedicineLoading) {
         removeContinuouslyUsedMedicine();
      }
   };

   return (
      <Tooltip
         testId={'deleteContinuouslyUsedMedicine'}
         content={translationKeys.medicine.continuouslyUsedMedicine.removeMedicineFromContinuouslyUsedMedicines}
      >
         <DeleteContinuousMedicationEventInterceptor medicineName={props.medicineName}>
            <IconWrapper
               onClick={handleClick}
               fillColor={IconFillColor.PRIMARY}
               testId={'deleteContinuouslyUsedMedicine'}
            >
               {props.medicineValid ? <ContinuouslyUsedMedicineIcon /> : <RemoveIcon />}
            </IconWrapper>
         </DeleteContinuousMedicationEventInterceptor>
      </Tooltip>
   );
};

export { DeleteContinuouslyUsedMedicineButton };
